module.exports = __webpack_public_path__ + "img/exclamation-icon.2973cbc8.svg";